


const EnvoieReducer = (state, action) => {
    switch (action.type) {
        case "GET_ENVOIS_START":
            return {
                ...state,
                envois: [],
                isFetching: true,
                error: false,
            };
        case "GET_ENVOIS_SUCCESS":
            return {
                ...state,
                envois: action.payload.envois,
                count: action.payload.count,
                isFetching: false,
                error: false,
            };
        case "GET_ENVOIS_FAILURE":
            return {
                ...state,
                envois: [],
                isFetching: false,
                error: action.payload,
            };
        case "GET_ENVOIE_START":
            return {
                ...state,
                envoie: {},
                isFetchingGet: true,
                errorGet: false,
            };
        case "GET_ENVOIE_SUCCESS":
            return {
                ...state,
                envoie: action.payload.envoie,
                isFetchingGet: false,
                errorGet: false,
            };
        case "GET_ENVOIE_FAILURE":
            return {
                ...state,
                envoie: {},
                isFetchingGet: false,
                errorGet: action.payload,
            };
        case "ADD_ENVOIE_START":
            return {
                ...state,
                envoie: {},
                isFetchingAdd: true,
                errorAdd: false,
            };
        case "ADD_ENVOIE_SUCCESS":
            return {
                ...state,
                envoie: action.payload.envoie,
                isFetchingAdd: false,
                errorAdd: false,
            };
        case "ADD_ENVOIE_FAILURE":
            return {
                ...state,
                envoie: {},
                isFetchingAdd: false,
                errorAdd: action.payload,
            };
        case "UPDATE_ENVOIE_START":
            return {
                ...state,
                envoieUpdate: {},
                isFetchingUpdate: true,
                errorUpdate: false,
            };
        case "UPDATE_ENVOIE_SUCCESS":
            return {
                ...state,
                envoieUpdate: action.payload.envoie,
                isFetchingUpdate: false,
                errorUpdate: false,
            };
        case "UPDATE_ENVOIE_FAILURE":
            return {
                ...state,
                envoieUpdate: {},
                isFetchingUpdate: false,
                errorUpdate: action.payload,
            };
        case "RESTART_ENVOIE":
            return{
                ...state,
                envoie: {},
                envoieUpdate: {},
                cost: "",
            }
        case "SIMULATE_COST_START":
            return {
                ...state,
                cost: "",
                isFetchingSimulate: true,
                errorSimulate: false,
            };
        case "SIMULATE_COST_SUCCESS":
            return {
                ...state,
                cost: action.payload.cost,
                isFetchingSimulate: false,
                errorSimulate: false,
            };
        case "SIMULATE_COST_FAILURE":
            return {
                ...state,
                cost: "",
                isFetchingSimulate: false,
                errorSimulate: action.payload,
            };
        case "GET_HISTORIES_ENVOIE_START":
            return {
                ...state,
                histories: [],
                isFetchingHistories: true,
                errorHistories: false,
            };
        case "GET_HISTORIES_ENVOIE_SUCCESS":
            return {
                ...state,
                histories: action.payload.histories,
                isFetchingHistories: false,
                errorHistories: false,
            };
        case "GET_HISTORIES_ENVOIE_FAILURE":
            return {
                ...state,
                histories: [],
                isFetchingHistories: false,
                errorHistories: action.payload,
            };
        case "CLEAR":
            return {
                envoie: {},
            }
        default:
            return { ...state };
    }
}

export default EnvoieReducer;